import request from "../libs/request";

import { BuildingIdType } from "../types/building";
import {
  GoodsItemType,
  GoodsListRequest,
  GoodsStoreJsonCode,
  RequestGoodsRentalResponse,
} from "../types/goods";

import { GoodsServiceRentItem } from "./goodsRequestServices";
import { SatisfactionInfo } from "./spaceReservationServices";
import { PageableResponse } from "./talkServices";

const baseUrl = "/goods/rental";

export const getGoodsRentalList = async (
  buildingId: BuildingIdType,
  params: GoodsListRequest
) =>
  request.get<PageableResponse<GoodsItemType>>(
    `${baseUrl}/list/${buildingId}`,
    { params }
  );

export const getGoodsRentalListDetail = async (stockId: string) =>
  request.get<GoodsItemType>(`${baseUrl}/list/detail/${stockId}`);

export const getGoodsRentalDetailHistory = async (goodsServiceId: string) =>
  request.get<GoodsItemType[]>(`${baseUrl}/detail/history/${goodsServiceId}`);

export const requestGoodsRental = async (stockId: string) =>
  request.post<RequestGoodsRentalResponse>(`${baseUrl}/${stockId}`);

export const cancelGoodsRental = async (goodsServiceId: string) =>
  request.patch(`${baseUrl}/${goodsServiceId}/cancel`);

export const getGoodsRentalDetail = async (goodsServiceId: string) =>
  request.get<GoodsServiceRentItem>(`${baseUrl}/detail/${goodsServiceId}`);

export const rentGoodsRental = async (
  goodsServiceId: string,
  params: GoodsStoreJsonCode
) => request.put(`${baseUrl}/${goodsServiceId}/rented`, params);

export const completeGoodsRental = async (
  goodsServiceId: string,
  params: GoodsStoreJsonCode
) => request.put(`${baseUrl}/${goodsServiceId}/complete`, params);

export type GoodsRentalSatisfactionRequest = {
  storeId?: string;
  isReply: boolean;
  page?: number;
  pageSize?: number;
};

export const getGoodsRentalSatisfactionList = async (
  params: GoodsRentalSatisfactionRequest
) =>
  request.get<PageableResponse<SatisfactionInfo>>(
    `${baseUrl}/satisfactionList`,
    { params }
  );
